import { IRequest } from 'legacy/lut/classes/models/onboarding/IRequest'
import { OnbPageURLs } from 'legacy/lut/classes/models/onboarding/Onboarding'
import { ISelectedRequest } from 'legacy/lut/classes/services/PartnerStoreService'
import { history } from 'legacy/lut/helpers/route'
import { lookupGetStateOld, setNextLookupState } from 'legacy/lut/store'

import { deleteParamsFromUrl, getUrlWithParams } from 'core-components/helpers/url'

export const REQ_NAV_STORAGE_KEY = 'onboarding_opened_requests'

export enum RequestLink {
  Onboarding = 'onb-requests',
  Exception = 'commercial-exceptions',
  Contract = 'contract-requests',
  RetailException = 'retail-exceptions',
  RetailOnboarding = 'onboarding-retail',
  BPRegistration = 'bp-registration-requests',
}

type TRequestDataToOpen = Pick<IRequest, 'EntryId' | 'PartnerName' | 'Type'>
interface IOpenRequestProps {
  item: TRequestDataToOpen
  url?: string
  sameTab?: boolean
}

export const openRequest = ({ item, url, sameTab }: IOpenRequestProps) => {
  const lookupOldState = lookupGetStateOld()

  const openedRequest: ISelectedRequest[] = [...lookupOldState.onboarding.openedRequests].filter(
    (el) => +el.reqId !== item.EntryId
  )
  openedRequest.unshift({
    reqId: `${item.EntryId}`,
    partnerName: item.PartnerName,
    type: RequestLink[item.Type],
  })

  localStorage.setItem(REQ_NAV_STORAGE_KEY, JSON.stringify(openedRequest))

  setNextLookupState({
    ...lookupOldState,
    onboarding: { ...lookupOldState.onboarding, openedRequests: openedRequest },
  })
  const requestUrl = getUrlWithParams(
    {
      rid: item.EntryId,
    },
    `page/${url || OnbPageURLs.RequestDetail}`
  )
  if (sameTab) {
    history.push(requestUrl)
  } else {
    window.open(requestUrl, '_blank')
  }
}

export const clearRequest = (reqId: number) => {
  const lookupOldState = lookupGetStateOld()

  const newOpenedRequestList: ISelectedRequest[] = lookupOldState.onboarding.openedRequests.filter(
    (el: ISelectedRequest) => +el.reqId !== reqId
  )
  localStorage.setItem(REQ_NAV_STORAGE_KEY, JSON.stringify(newOpenedRequestList))
  setNextLookupState({
    ...lookupOldState,
    onboarding: {
      ...lookupOldState.onboarding,
      openedRequests: newOpenedRequestList,
    },
  })
}

export const clearAllRequests = () => {
  const lookupOldState = lookupGetStateOld()

  localStorage.setItem(REQ_NAV_STORAGE_KEY, '')
  setNextLookupState({
    ...lookupOldState,
    onboarding: { ...lookupOldState.onboarding, openedRequests: [] },
  })
}

export const initOpenedReqState = () => {
  const lookupOldState = lookupGetStateOld()
  const storage = localStorage.getItem(REQ_NAV_STORAGE_KEY)
  if (!lookupOldState.onboarding.openedRequests.length && storage) {
    setNextLookupState({
      ...lookupOldState,
      onboarding: {
        ...lookupOldState.onboarding,
        openedRequests: JSON.parse(storage),
      },
    })
  }
}
export const onMenuItemClick = (menuItem: ISelectedRequest) => {
  history.push(
    getUrlWithParams(
      { page: OnbPageURLs.RequestDetail, rid: menuItem.reqId },
      deleteParamsFromUrl(['EntryId', 'form', 'tab-request-detail'])
    )
  )
}
export const onClickBack = (item: ISelectedRequest) => {
  history.push(
    getUrlWithParams(
      { page: item.type },
      deleteParamsFromUrl(['EntryId', 'form', 'tab-request-detail', 'rid'])
    )
  )
}
